import { forEach } from "lodash";
import { IQService, ICacheFactoryService } from "angular";
declare var Drupal: any;

export class MatchService {
    private cache: any;

    public static $inject = ["$resource", "$q", "$cacheFactory"];
    constructor(private $resource, private $q: IQService, private $cacheFactory: ICacheFactoryService) {
        this.cache = this.$cacheFactory("match_list_cache");
    }

    public getMatch(matchId) {
        // Check if the match - list includes an entry
        const deferred = this.$q.defer();
        const matchList = this.cache.get("match_list");

        if (typeof matchList !== "undefined") {
            if (matchList.hasOwnProperty(matchId)) {
                deferred.resolve(matchList[matchId]);
            } else {
                deferred.reject("match_not_found");
            }
        } else {
            deferred.reject("match_list is empty");
        }

        return deferred.promise;
    }

    public getMatches(leagueId, limit, limitByStatus, maxAgeClosed) {
        const deferred = this.$q.defer();
        const matchList = this.cache.get("match_list");

        // Check if we need to fetch the data
        if (typeof matchList !== "undefined") {
            deferred.resolve(this.cache.get("match_list"));
        } else {
            // Init query string values
            const queryStringValues = [];

            // Assign limit to query - string
            if (limit > 0) {
                queryStringValues.push("limit=" + limit);
            }

            // Check if the limit by status object is available / limits are set
            let idx;
            for (idx in limitByStatus) {
                if (limitByStatus.hasOwnProperty(idx) && limitByStatus[idx] > 0) {
                    queryStringValues.push("limit." + idx + "=" + limitByStatus[idx]);
                }
            }

            if (typeof maxAgeClosed !== "undefined") {
                queryStringValues.push("date.closed.max=" + maxAgeClosed);
            }

            // Build url and query the web-service
            this.$resource(Drupal.settings.eslapi_host + "/leagues/:leagueId/matches?:queryString")
                .query({
                    leagueId: leagueId,
                    queryString: queryStringValues.join("&"),
                })
                .$promise.then(function(data) {
                    const cachedData = {};
                    forEach(data, function(value) {
                        cachedData[value.id] = value;
                    });

                    this.cache.put("match_list", cachedData);
                    // Signalize "data" filled
                    deferred.resolve(this.cache.get("match_list"));
                });
        }
        // Return promise
        return deferred.promise;
    }
}
